module.exports = __webpack_public_path__ + "static/media/10.20c3d93e.png";